// System Features Getters

export const getSystemMenu = state => {
  return state.systemMenu
}
